var exports = {
  "k": "xcc377c0b--9df8c0--container",
};

module.exports = exports;
